import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Header.css';

const Header = ({ title, showBack = false, showClose = false, onClose }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      window.history.back();
    }
  };

  return (
    <div className="header">
      {showBack && (
        <span className="header-btn back-btn" onClick={handleBack}>
          ‹
        </span>
      )}
      {showClose && (
        <span className="header-btn close-btn" onClick={handleClose}>
          ×
        </span>
      )}
      {!showBack && !showClose && <span className="header-btn"></span>}

      <h1 className="header-title">{title}</h1>

      <span className="header-btn menu-btn">⋯</span>
    </div>
  );
};

export default Header;
